const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Google Analytics component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {Companies} Companies injected to gain access to the Companies resource
 */
app.directive('googleAnalyticsSettings', ['Application', 'Authorization', 'Companies', function (Application, Authorization, Companies) {
  return {
    restrict: "E",
    replace: true,
    scope : {},
    template: require('../../templates/directives/google-analytics-settings.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.company = Authorization.getAuthToken().company;
      self.loading = false;
      self.exists = false;
      self.editing = true;
      self.addId = '';
      if (self.company && self.company.google_analytics) {
        self.exists = true;
        self.editing = false;
      }

      self.send = function() {
        Companies.googleAnalytics({UA: self.addId}).$promise
        .then(function(results) {
          if (results && results.google_analytics) {
            Application.messaging.addMessage({type: 'success', duration: 5, text: 'The provided Property ID has been configured for Google Analytics.'});
            self.addId = '';
            self.exists = true;
            self.editing = false;
            self.company.google_analytics = results.google_analytics;
            return;
          }
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'The property ID was not save. Please contact Support.'});
        }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'The property ID was not save. Please contact Support.'});
        });
      };
    }],
    controllerAs: 'analytics'
  }
}]);